module.exports = __webpack_public_path__ + "static/media/welcome-face.d70f1959.png";